export const PromoPackSourceType = {
  Moment5Pack: 1,
} as const;

export const PromoPackName = {
  Moment5Pack: 'Moment 5-Pack',
  OnboardingPack: 'Onboarding Pack',
} as const;

export function getPromoPackName(sourceType: number): string {
  switch (sourceType) {
    case PromoPackSourceType.Moment5Pack:
      return PromoPackName.Moment5Pack;
    default:
      return PromoPackName.OnboardingPack;
  }
}
